import React, {useState} from 'react'
import {Collapse, makeStyles} from "@material-ui/core";
import OpinionElementContent from "./OpinionElementContent";
import OpinionElementTitle from "./OpinionElementTitle";
import PropTypes from "prop-types";

const useStyle = makeStyles(theme => ({
    root: {
        border: `solid 1px ${theme.palette.primary.main}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper,
        padding: `${theme.spacing()}px ${theme.spacing(2)}px`,
        marginBottom: theme.spacing()
    }
}))

function OpinionElement(
    {
        index,
        groupId,
        opinion,
        coordinatorView,
        search,
        editable,
        apiPathType
    }) {
    const classes = useStyle();
    const [open, setOpen] = useState(false);


    return (<Collapse in={!search.search || opinion.memberName.toLowerCase().indexOf(search.search.toLowerCase()) > -1} unmountOnExit={false}>
        <div className={classes.root}>
            <OpinionElementTitle
                index={index}
                opinion={opinion}
                open={open}
                onOpen={() => setOpen(!open)}
                coordinatorView={coordinatorView}
                editable={editable}
            />
            <Collapse in={coordinatorView || open} unmountOnExit>
                <OpinionElementContent
                    groupId={groupId}
                    opinion={opinion}
                    index={index}
                    coordinatorView={coordinatorView}
                    editable={editable}
                    apiPathType={apiPathType}
                />
            </Collapse>
        </div>
    </Collapse>)
}

OpinionElement.propTypes = {
    groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    index: PropTypes.number.isRequired,
    opinion: PropTypes.object.isRequired,
    coordinatorView: PropTypes.bool.isRequired,
    search: PropTypes.shape({
        search: PropTypes.string
    }),
    editable: PropTypes.bool.isRequired,
}

export default OpinionElement;